import "/style/style.css";

import { setBasePath } from "@awesome.me/webawesome/dist/webawesome.js";

setBasePath("/path/to/webawesome/dist");

import "@awesome.me/webawesome/dist/components/tab-group/tab-group.js";
import "@awesome.me/webawesome/dist/components/badge/badge.js";
import "@awesome.me/webawesome/dist/components/tab/tab.js";
import "@awesome.me/webawesome/dist/components/tab-panel/tab-panel.js";
import "@awesome.me/webawesome/dist/components/button/button.js";
import "@awesome.me/webawesome/dist/components/input/input.js";
import "@awesome.me/webawesome/dist/components/tree/tree.js";
import "@awesome.me/webawesome/dist/components/card/card.js";
import "@awesome.me/webawesome/dist/components/dialog/dialog.js";
import "@awesome.me/webawesome/dist/components/spinner/spinner.js";
import "@awesome.me/webawesome/dist/components/callout/callout.js";
import "@awesome.me/webawesome/dist/components/number-input/number-input.js";
import "@awesome.me/webawesome/dist/components/divider/divider.js";
import "@awesome.me/webawesome/dist/components/select/select.js";
import "@awesome.me/webawesome/dist/components/checkbox/checkbox.js";
import "@awesome.me/webawesome/dist/components/textarea/textarea.js";
import "@awesome.me/webawesome/dist/components/tooltip/tooltip.js";
import type { ApiError } from "./api";
import { $ } from "./query";
import { $el } from "./el";
import type WaTooltip from "@awesome.me/webawesome/dist/components/tooltip/tooltip.js";

export const error_callout_modal = (r: ApiError) => {
    const modal = $("#modal");
    let message: string;

    if (r.code === 400) {
        message =
            "Er is iets mis gegaan, controleer of alles correct is en probeer het opniew.";
    } else if (r.code === 404) {
        message = "Er is iets mis gegaan, we konden het helaas niet vinden.";
    } else if (r.code === 500) {
        message = "Er is iets mis gegaan, probeer het later opniew.";
    } else {
        message = "Er is iets mis gegaan.";
    }

    modal.querySelector("wa-callout")?.remove();

    modal.prepend(
        $el(
            "wa-callout",
            { variant: "danger" },
            message,
            $el("wa-icon", { slot: "icon", name: "circle-exclamation" }),
        ),
    );
};
export function showTooltip(element: HTMLElement, content: string) {
    if (!element.id) {
        element.id = `anchor-${crypto.randomUUID()}`;
    }

    const popover = document.createElement("wa-tooltip") as WaTooltip;
    popover.setAttribute("for", element.id);
    popover.innerHTML = content;

    document.body.appendChild(popover);

    popover.addEventListener("wa-hide", () => popover.remove());

    requestAnimationFrame(() => {
        popover.show();
    });

    return popover;
}
